import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-contractchangelicenseplate',
  templateUrl: './contractchangelicenseplate.component.html',
  styleUrls: ['./contractchangelicenseplate.component.css']
})
export class ContractChangeLicenseplateComponent implements OnInit {
    constructor(public dialogRef: MatDialogRef<ContractChangeLicenseplateComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any) {
    }
    ngOnInit() {

    }

    onNoClick(): void {
      this.dialogRef.close();
    }
}
